// extracted by css-extract-rspack-plugin
export default {"answer":"Answer_answer__0789k","answerBody":"Answer_answerBody__x8aQ3"};